"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.megafoot = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var MegaMenuAction_1 = require("@/pages/common/actions/MegaMenuAction");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.layout.megafoot), { lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1, linkCareers: state.layout.careerUrl })); };
var mapDispatchToProps = function (dispatch) { return ({
    onSubscribeEmailChange: function (email) { return dispatch(MegaMenuAction_1.default.onSubscribeEmailChange(email)); },
    onSubscribeSubmit: function () { return dispatch(MegaMenuAction_1.default.onSubscribeSubmit()); }
}); };
exports.megafoot = function (props) {
    var t = props.t;
    var lang = props.lang;
    var subscribeInputAttr = props.subscribeIsLoading ? { disabled: true } : {};
    var onSubscribeKeydown = function (e) {
        if (e.keyCode !== 13)
            return;
        props.onSubscribeSubmit();
    };
    var onSubscribeSubmitClick = function () {
        props.onSubscribeSubmit();
    };
    return (React.createElement("div", { className: "l-megafoot" },
        React.createElement("div", { className: "l-megafoot__body" },
            React.createElement("div", { className: "l-megafoot__nav" },
                React.createElement("ul", { className: "c-megafoot__nav" },
                    React.createElement("li", null,
                        React.createElement("a", { className: "c-megafoot__label", href: "/" + lang + "/property-search/buy" }, t.clientServices),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-search/buy" }, t.buy)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-search/rent" }, t.rent)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/exclusives" }, t.ourExclusive)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/list-property" }, t.list)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/firsthand-developments" }, t.newDevelopments)))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "c-megafoot__label", href: "/" + lang + "/property-agent-team" }, t.agents),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-agent-team" }, t.findAnAgent)),
                            React.createElement("li", null,
                                React.createElement("a", { href: props.linkCareers }, t.joinUsAsAgent)))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "c-megafoot__label", href: "/" + lang + "/about-us" }, t.aboutUs),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/about-us" }, t.ourStory)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-experts" }, t.executiveTeam)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-agent-team" }, t.ourTeam)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/about-us/testimonials" }, t.testimonial)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/about-us/in-the-press" }, t.inThePress)))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "c-megafoot__label", href: "" }, t.resources),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-news" }, t.newsAndInsights)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-questions" }, t.askAnAgent)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/property-guides" }, t.guides)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/mortgagecalculator/monthlyrepayment" }, t.mortgageCalculator)))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "c-megafoot__label", href: "/" + lang + "/communication/enquiry" }, t.support),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/general/faq" }, t.faq)),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/" + lang + "/communication/enquiry" }, t.contactUs)))))),
            React.createElement("div", { className: "l-megafoot__connect" },
                React.createElement("div", { className: "c-megafoot__label" }, t.letsConnect),
                React.createElement("div", { className: "c-megafoot__socialicons" },
                    React.createElement("a", { href: props.linkInstagram, target: "_blank", title: "Instagram", className: "c-megafoot__socialicon" },
                        React.createElement("span", { className: "fab fa-instagram" })),
                    React.createElement("a", { href: props.linkFacebook, target: "_blank", title: "Facebook", className: "c-megafoot__socialicon" },
                        React.createElement("span", { className: "fab fa-facebook" })),
                    React.createElement("a", { href: props.linkLinkedIn, target: "_blank", title: "Linkedin", className: "c-megafoot__socialicon" },
                        React.createElement("span", { className: "fab fa-linkedin" })),
                    React.createElement("a", { href: props.linkYoutube, target: "_blank", title: "YouTube", className: "c-megafoot__socialicon" },
                        React.createElement("span", { className: "fab fa-youtube" }))),
                React.createElement("div", { className: "c-megafoot__subscribe" },
                    React.createElement("div", { className: "c-megafoot__subscribetitle" }, t.subscribeTitle),
                    React.createElement("div", { className: "c-megafoot__subscribeinput" },
                        React.createElement("input", __assign({}, subscribeInputAttr, { onChange: function (e) { return props.onSubscribeEmailChange(e.target.value); }, value: props.subscribeEmail, onKeyDown: onSubscribeKeydown, type: "email", placeholder: t.subscribePlaceholder })),
                        React.createElement("button", { onClick: onSubscribeSubmitClick }, props.subscribeIsLoading ? (React.createElement("span", { className: "fal fa-spinner fa-spin" })) : (React.createElement("span", { className: "fal fa-arrow-right" }))))),
                React.createElement("div", { className: "c-megafoot__address" }, t.address),
                React.createElement("div", { className: "c-megafoot__phone" }, t.phone)),
            React.createElement("div", { className: "l-megafoot__privacy" },
                React.createElement("div", { className: "c-megafoot__privacy" },
                    React.createElement("a", { href: "/" + lang + "/general/privacypolicy" }, t.privacyPolicy),
                    React.createElement("a", { href: "/" + lang + "/general/termsandconditions" }, t.termsAndConditions)),
                React.createElement("div", { className: "c-megafoot__copyright" },
                    React.createElement("span", null,
                        "\u00A9 ",
                        props.copyrightYear,
                        " ",
                        t.companyName),
                    React.createElement("span", null,
                        t.eaaLicense,
                        " ",
                        t.eaaLicenseNumber),
                    React.createElement("span", null, t.allRightReserved)),
                React.createElement("div", { className: "c-megafoot__empty" })),
            React.createElement("div", { style: { gridColumn: '1 / 4', gridRow: '4 / 5', paddingBottom: "20px" } },
                React.createElement("div", { className: "c-megafoot__copyright" },
                    React.createElement("span", null, t.serviceFees))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.megafoot);
